import { render, staticRenderFns } from "./FormControlCheckbox.vue?vue&type=template&id=6b4ae1b8"
import script from "./FormControlCheckbox.vue?vue&type=script&lang=js"
export * from "./FormControlCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FormControlCheckbox.vue?vue&type=style&index=0&id=6b4ae1b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports